<div
    class="vl-app-light:flex vl-app-light:justify-between vl-app-light:items-center grid grid-cols-[4rem_1fr_4rem] pb-4 pt-4">
    <div>
        <ion-button
            class="var-app-light:text-primary text-xs font-bold normal-case text-secondary dark:text-contrast-yellow print:hidden"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="navigateBack()"
            fill="clear">
            <ion-icon
                class="vl-app-light:w-5 vl-app-light:h-5 vl-app-light:mt-1 mr-1 h-6 w-6 text-xl dark:filter-yellow"
                title="{{ 'LOCAL_BTN_BACK' | translate }}"
                attr.aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
        </ion-button>
    </div>
    <div class="flex-align-center flex justify-center">
        <h1 class="orb-app-light-dark:font-bold text-base font-semibold">{{ 'JOURNEY_PLAN' | translate }}</h1>
    </div>
    <div *ngIf="env.JOURNEY_PLANNER?.SHOW_ROUTE_SHARE">
        <ion-button
            class="var-app-light-dark:transform var-app-light-dark:scale-[1.1] text-xs font-bold normal-case text-secondary dark:filter-yellow dark:text-contrast-yellow print:hidden"
            [attr.aria-label]="'SHARE_LABEL' | translate"
            (click)="exportTravelPlan()"
            fill="clear"
            type="button">
            <ion-icon
                class="mr-1 h-[1.625rem] w-[1.625rem] text-xl text-secondary dark:text-contrast-yellow"
                src="{{ assetsPath$ | async }}/img/journey-planner/share-icon.svg"></ion-icon>
        </ion-button>
    </div>
    <div class="vl-app-light:hidden flex-align-center flex justify-end"></div>
</div>

<div class="grid grid-cols-[auto_1fr] break-words pb-4 pl-7 pr-7 text-base">
    <ion-label class="mr-2 text-[#666666] dark:text-contrast-yellow">{{ 'LOCAL_LABEL_FROM' | translate }}:</ion-label>
    <ion-label class="min-w-0">
        <ng-container [ngSwitch]="(search$ | async)?.origin?.name">
            <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{ 'LOCATION_FROM_MAP' | translate }}</span>
            <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate }}</span>
            <span *ngSwitchDefault>{{ (search$ | async)?.origin?.name }}</span>
        </ng-container>
        <span
            *ngIf="env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME && (search$ | async)?.origin?.municipalityName">
            ({{ (search$ | async)?.origin?.municipalityName }})
        </span>
    </ion-label>
    <ion-label class="mr-2 text-[#666666] dark:text-contrast-yellow">{{ 'LOCAL_LABEL_TO' | translate }}:</ion-label>
    <ion-label class="min-w-0">
        <ng-container [ngSwitch]="(search$ | async)?.destination?.name">
            <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{ 'LOCATION_FROM_MAP' | translate }}</span>
            <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate }}</span>
            <span *ngSwitchDefault>{{ (search$ | async)?.destination?.name }}</span>
        </ng-container>
        <span
            *ngIf="
                env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME && (search$ | async)?.destination?.municipalityName
            ">
            ({{ (search$ | async)?.destination?.municipalityName }})
        </span>
    </ion-label>
</div>
